var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_431_00000116208738672889563700000006983673509204597421_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_707_00000056397687370983664040000007105347016143990928_",
    d: "M97.9,89.1L75.7,66.9C89.5,48.2,85.5,22,66.9,8.2 S22-1.6,8.2,17S-1.6,61.9,17,75.7c14.8,10.9,35,10.9,49.8,0l22.2,22.2c2.3,2.6,6.3,2.8,8.8,0.5c2.6-2.3,2.8-6.3,0.5-8.8 C98.2,89.4,98.1,89.3,97.9,89.1 M12.8,42.1c0-16.2,13.1-29.3,29.3-29.3s29.3,13.1,29.3,29.3S58.3,71.4,42.1,71.4l0,0 C25.9,71.4,12.8,58.3,12.8,42.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.531b36fe2d9b55cf7a3748f55390d459.svg";
export { ForwardRef as ReactComponent };